import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import EndeavorPlayer from './components/endeavor-player';

class EndeavorPlayerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.render();
    }

    render() {
        ReactDOM.render(
            <EndeavorPlayer content={this.options} />,
            this.element
        );
    }
}

export default EndeavorPlayerComponent;
